module.exports = __webpack_public_path__ + "static/media/Nov12-F19.72aa93c4.png";